var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 125,
    viewBox: "0 0 109 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 0L108 31V93L54 124L0 93V31L54 0Z",
    fill: "#FAAC48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 7.62939e-06L54 30.281V92.7603V124L0 93L-7.62939e-06 31L54 7.62939e-06Z",
    fill: "#CF8C35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 76C52.2478 76 50.8872 74.3565 50.8183 72.8302L49.0002 49.6279L49.0002 37.907C48.9732 35.7429 51.5174 34 54 34C56.4826 34 59.0268 35.7429 58.9998 37.907V49.8491L57.1817 72.8302C57.1128 74.3565 55.7522 76 54 76ZM54 90C56.7614 90 59 87.7614 59 85C59 82.2386 56.7614 80 54 80C51.2386 80 49 82.2386 49 85C49 87.7614 51.2386 90 54 90Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningModalIcon);
export default __webpack_public_path__ + "static/media/warning-modal-icon.c1aa932e5825a39b6b5356f38d223d26.svg";
export { ForwardRef as ReactComponent };